import { Select, MenuItem, SelectChangeEvent } from '@mui/material'
import { CRON_EXPRESSION } from 'src/constants'
import { useState } from 'react'
import { IUpdateCronJobDto } from 'src/types/cron-jobs.type'

interface IProps {
  id: string
  isDisabled: boolean
  schedule: CRON_EXPRESSION
  handleUpdate: (id: string, data: IUpdateCronJobDto) => Promise<void>
}

export const CronScheduleSelect = ({ isDisabled, schedule, handleUpdate, id }: IProps) => {
  const [selectedExpression, setSelectedExpression] = useState<CRON_EXPRESSION>(schedule)

  const handleChange = (event: SelectChangeEvent<string>) => {
    setSelectedExpression(event.target.value as CRON_EXPRESSION)
    handleUpdate(id, { schedule: event.target.value as CRON_EXPRESSION })
  }

  return (
    <Select
      disabled={isDisabled}
      size="small"
      autoWidth
      value={selectedExpression}
      onChange={handleChange}
      MenuProps={{ style: { maxHeight: '400px' } }}
      sx={{
        fontSize: '12px',
        border: 'none',
        boxShadow: 'none',
        '& .MuiOutlinedInput-notchedOutline': { display: 'none' },
      }}
    >
      {Object.entries(CRON_EXPRESSION).map(([key, value]) => (
        <MenuItem key={key} value={value}>
          {key}
        </MenuItem>
      ))}
    </Select>
  )
}
